import React, { useState, useEffect, useRef, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import PlatformWrapper from '../platform-wrapper';
import apis from '../../api';
import { Select, Spin } from 'antd';
import './index.less';
import { formateTimeStamp } from '@/common/utils';
import TimeLineNew from '@/components/time-line-new';
import goto from '@/common/goto';
import './index.less';
import ComponentLog from '@/components/component-log';
import utils from '@/common/utils';
import { useActivityInfo } from '@/components/activity-detail2';
import Empty from '@/components/core-empty';

const { Option } = Select;

const MercahntActivityIntro = () => {
  const [list, setList] = useState('');
  const [planCode, setPlanCode] = useState('');
  const [actInfo, setActInfo] = useState('');

  const loadRef = useRef(null);
  loadRef.current = actInfo.loading;

  const [activityInfo = {}, loadStatus] = useActivityInfo(planCode);
  // 是否是开放报名
  const isOpenArea = useMemo(() => activityInfo.businessNewStep === 1, [activityInfo]);

  useEffect(() => {
    apis.homeBizActivities({ type: 1, currentPage: 1, pageSize: 10 }).then((res) => {
      if (res.ret === '0' && res.data) {
        setList(res.data.list);
        if (res.data.list.length > 0) {
          setPlanCode(res.data.list[0].planCode);
        }
      }
    });
  }, []);
  useEffect(() => {
    if (!planCode) return;
    if (loadRef.current) return;
    setActInfo({ loadind: true });
    apis.homeActivitySummary({ planCode }).then((res) => {
      if (res.ret === '0' && res.data) {
        setActInfo({ ...res.data, loading: false });
      }
    });
  }, [planCode]);

  const selectRef = useRef(null);

  const options = useMemo(() => {
    const {
      activityStatus,
      businessStartTime,
      businessEndTime,
      activityStartTime,
      activityEndTime,
      applyCount,
      applicants,
      roomCount,
      promotionCount,
      currentTime,
      activityName,
    } = actInfo;
    return [
      {
        title: '招商报名',
        cardStyle: { minWidth: '150px' },
        body:
          activityStatus === 0 ? (
            '招商规则还未设置~'
          ) : (
            <>
              {/* <p>报名商品数:{applyCount}</p> */}
              {/* <p>报名人数:{applicants}</p> */}
              <p>
                报名商品数:
                {applyCount >= 10000 ? <>{utils.formatPrice(applyCount / 10000)}万</> : applyCount}
              </p>
              <p>
                报名人数:
                {applicants >= 10000 ? <>{utils.formatPrice(applicants / 10000)}万</> : applicants}
              </p>
            </>
          ),
        footer:
          activityStatus === 0 ? (
            <ComponentLog>
              <span clstag="resource_1627030927203|29" onClick={() => goto.merchantActivityEdit(planCode).push()}>
                立即设置
              </span>
            </ComponentLog>
          ) : (
            <ComponentLog>
              <span clstag="resource_1627030927203|30" onClick={() => goto.merchantActivityWare(planCode).push()}>
                详情
              </span>
            </ComponentLog>
          ),
        show() {
          return true;
        },
        isLight: currentTime > businessStartTime && currentTime < businessEndTime,
      },
      {
        // divide: <div className="merchants-time-line-divide" />,
        title: '主推品盘货',
        body: (() => {
          if (currentTime < businessStartTime || activityStatus === 0) {
            return <p>盘货未开始~</p>;
          } else if (currentTime > activityEndTime) {
            return <p>盘货已结束~</p>;
          } else {
            return <p>盘货进行中~</p>;
          }
        })(),
        footer:
          activityStatus === 1 ? (
            <ComponentLog>
              <span clstag="resource_1627030927203|31" onClick={() => goto.merchantActivityInventory(planCode).push()}>
                详情
              </span>
            </ComponentLog>
          ) : null,
        show() {
          // 主推品盘货 || 我的商品
          return !isOpenArea;
        },
        isLight: currentTime > businessStartTime && currentTime < activityEndTime,
      },
      {
        // divide: <div className="merchants-time-line-divide" />,
        title: '会场搭建',
        body: roomCount ? <p>已搭建{roomCount}个会场~</p> : <p>活动会场还未搭建~</p>,
        footer:
          activityStatus === 1 ? (
            <span
              onClick={() => {
                goto.merchantRoomMyCreate(planCode).push();
              }}
            >
              {roomCount ? (
                <ComponentLog>
                  <span clstag="resource_1627030927203|33">详情</span>
                </ComponentLog>
              ) : (
                <ComponentLog>
                  <span clstag="resource_1627030927203|32">立即搭建</span>
                </ComponentLog>
              )}
            </span>
          ) : null,
        show() {
          // 会场活动 || 综促活动
          return true;
        },
        isLight: currentTime > businessStartTime && currentTime < activityEndTime,
      },
      {
        // divide: <div className="merchants-time-line-divide" />,
        title: '促销创建',
        body: promotionCount ? <p>已创建{promotionCount}个促销活动~</p> : <p>促销活动还未创建~</p>,
        footer:
          activityStatus === 1 ? (
            <span onClick={() => goto.merchantPromotionMyCreate(planCode).push()}>
              {promotionCount ? (
                <ComponentLog>
                  <span clstag="resource_1627030927203|35">详情</span>
                </ComponentLog>
              ) : (
                <ComponentLog>
                  <span clstag="resource_1627030927203|34">立即创建</span>
                </ComponentLog>
              )}
            </span>
          ) : null,
        show() {
          return true;
        },
        isLight: currentTime > businessStartTime && currentTime < activityEndTime,
      },
      {
        // divide: <CaretRightOutlined />,
        divide: <span className="san-jiao"></span>,
        title: '活动上线',
        body:
          currentTime > activityStartTime ? (
            currentTime < activityEndTime ? (
              <p>活动正在进行中~</p>
            ) : (
              <p>活动已结束，快来复盘吧~</p>
            )
          ) : (
            <p>活动还未开始~</p>
          ),
        footer: (() => {
          if (activityStatus === 0 || currentTime < activityStartTime) {
            return null;
          } else if (currentTime > activityStartTime && currentTime < activityEndTime) {
            return (
              <ComponentLog>
                <span clstag="resource_1627030927203|36" onClick={() => goto.toDataPanelRealTimeData(planCode).push()}>
                  查看数据
                </span>
              </ComponentLog>
            );
          } else {
            return (
              <ComponentLog>
                <span
                  clstag="resource_1627030927203|37"
                  onClick={() =>
                    goto
                      .toDataPanelAnalysisReport(planCode, activityName, activityStartTime, activityEndTime, '全部会场')
                      .push()
                  }
                >
                  生成数据报告
                </span>
              </ComponentLog>
            );
          }
        })(),
        show() {
          return true;
        },
        isLight: currentTime > activityStartTime && currentTime < activityEndTime,
      },
    ];
  }, [planCode, actInfo, isOpenArea]);

  return (
    <PlatformWrapper
      title={`主题活动管理` + (list.length ? `  (${list.length})` : '')}
      hasMore={false}
      background="#FFFFFF"
      wrapperRight={
        list.length > 0 && (
          <ComponentLog>
            <div ref={selectRef}>
              <Select
                clstag="resource_1627030927203|28"
                value={planCode}
                className="merchant-activity-select"
                getPopupContainer={() => selectRef.current}
                onChange={(e) => setPlanCode(e)}
                style={{ width: 190 }}
              >
                {list.map((item) => {
                  return (
                    <Option key={item.planCode} value={item.planCode}>
                      {item.activityName}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </ComponentLog>
        )
      }
      className="merchant-activity-wrapper"
    >
      {list.length > 0 ? (
        <Spin spinning={loadRef.current}>
          <div className="merchant-activity-body">
            <div className="merchant-activity-title">
              <span className="name">{actInfo.activityName}</span>
              <span className="level">{actInfo.levelName}</span>
            </div>
            <div className="merchant-activity-desc">
              <span>活动ID：{actInfo.planCode}</span>
              <span>
                活动时间：{actInfo.pendingActivityBeginTime || formateTimeStamp(actInfo.activityStartTime)}至
                {actInfo.pendingActivityEndTime || formateTimeStamp(actInfo.activityEndTime)}
              </span>
              {actInfo.currentTime > actInfo.businessStartTime && actInfo.currentTime < actInfo.businessEndTime ? (
                <span>招商截止时间：{formateTimeStamp(actInfo.businessEndTime)}</span>
              ) : null}
            </div>
            <TimeLineNew options={options} />
          </div>
        </Spin>
      ) : (
        <Empty className="merchant-activity-empty" />
      )}
    </PlatformWrapper>
  );
};

export default withRouter(MercahntActivityIntro);
